import { partnerApi, type ApiResponse } from '../../../lib/api';
import { API_ENDPOINTS } from '../../../lib/constants';

export interface SegmentDefinitionSummary {
  id: string;
  name: string;
  description: string | null;
  canonicalVersionId: string;
  updatedAt: string | null;
  /** null = all tenants, [] = none (Draft), non-empty = only those business IDs. */
  targetedTenantsFilter?: string[] | null;
}

interface SegmentDefinitionsResponse {
  segmentDefinitions: SegmentDefinitionSummary[];
}

export async function getSegmentDefinitions(): Promise<SegmentDefinitionSummary[]> {
  const response = await partnerApi.request<ApiResponse<SegmentDefinitionsResponse>>(
    API_ENDPOINTS.PARTNER.SEGMENT_DEFINITIONS,
  );
  return response.data.segmentDefinitions;
}
